export default class MouseDrag {
    constructor(el, callback) {
        this.el = el;
        this.callback = callback;
        this.pageX = 0;
        this.pageY = 0;
        this.bind();
    }

    bind() {
        this.el.addEventListener('pointerdown', (e) => this.mouseDown(e));
        this.el.addEventListener('pointerup', (e) => this.mouseUp(e));
    }

    mouseDown(e) {
        this.pageX = e.pageX;
        this.pageY = e.pageY;
    }

    mouseUp(e) {
        if (e.pageX !== this.pageX || e.pageY !== this.pageY) {
            this.callback();
        }

        this.pageX = 0;
        this.pageY = 0;
    }
}
